import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { PersonelDetail } from '../model'

export function ManagerNoteCard({ notlar }: { notlar: PersonelDetail['perf']['notlar'] }) {
  const { t } = useTranslation()
  const [idx, setIdx] = useState(0)
  const count = notlar.length
  const note = notlar[Math.min(idx, Math.max(count - 1, 0))]
  if (!note) return null

  return (
    <div className="flex min-h-[180px] flex-col rounded-xl border border-border/70 bg-muted/30 px-4 py-3">
      <div className="mb-2 flex items-center justify-between gap-2">
        <div className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">
          {t('hr.personel.perf.yoneticiNot')}
        </div>
        <div className="text-[11px] tabular-nums text-muted-foreground">
          {idx + 1}/{count}
        </div>
      </div>
      <blockquote className="min-h-0 flex-1 text-sm leading-relaxed text-muted-foreground">“{note.metin}”</blockquote>
      <div className="mt-3 flex items-end justify-between gap-2">
        <div className="min-w-0">
          <div className="text-xs font-semibold text-foreground">
            {note.yazar}
            <span className="font-normal text-muted-foreground"> · {note.unvan}</span>
          </div>
          <div className="mt-0.5 text-[11px] text-muted-foreground">{note.tarih}</div>
        </div>
        {count > 1 ? (
          <div className="flex shrink-0 items-center gap-1">
            <Button
              type="button"
              variant="outline"
              size="icon"
              className="size-7 bg-card"
              onClick={() => setIdx((i) => (i - 1 + count) % count)}
              aria-label={t('hr.personel.perf.oncekiNot')}
            >
              <ChevronLeft className="size-3.5" />
            </Button>
            <div className="flex items-center gap-1 px-1">
              {notlar.map((n, i) => (
                <button
                  key={n.id}
                  type="button"
                  aria-label={`${i + 1}`}
                  className={cn(
                    'size-1.5 rounded-full transition-colors',
                    i === idx ? 'bg-primary' : 'bg-muted-foreground/30 hover:bg-muted-foreground/50',
                  )}
                  onClick={() => setIdx(i)}
                />
              ))}
            </div>
            <Button
              type="button"
              variant="outline"
              size="icon"
              className="size-7 bg-card"
              onClick={() => setIdx((i) => (i + 1) % count)}
              aria-label={t('hr.personel.perf.sonrakiNot')}
            >
              <ChevronRight className="size-3.5" />
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  )
}
